export default {
  // General
  'About {appName}': 'About {appName}',
  'About Enable Banking API': 'About Enable Banking API',
  'Application description is not provided.': 'Application description is not provided.',
  'Authenticate': 'Authenticate',
  'Authentication method': 'Authentication method',
  'Authentication session has expired': 'Authentication session has expired',
  'Cancel': 'Cancel',
  'Click {0} button if you have confirmed authorization in the BankID app.': 'Click {0} button if you have confirmed authorization in the BankID app.',
  'Continue authentication': 'Continue authentication',
  'Cookies must be enabled in your browser to continue': 'Cookies must be enabled in your browser to continue',
  'Enter your OTP code with index {0}': 'Enter your OTP code with index {0}',
  'Error during authentication:': 'Error during authentication:',
  'Error while updating authentication status': 'Error while updating authentication status',
  'OTP code': 'OTP code',
  'Open the BankID app on this device': 'Open the BankID app on this device',
  'Redirecting to your account servicing provider': 'Redirecting to your account servicing provider',
  'Returning to the authentication initiator': 'Returning to the authentication initiator',
  'Start the BankID app on your mobile device and tap the QR code button in the app to scan the QR code on this page': 'Start the BankID app on your mobile device and tap the QR code button in the app to scan the QR code on this page',
  'or': 'or',
  'Starting authorization': 'Starting authorization',
  'To continue please use your authentication app': 'To continue please use your authentication app',
  'Try again': 'Try again',
  'Submit': 'Submit',
  'Unable to access server': 'Unable to access server',
  'Unable to authenticate': 'Unable to authenticate',
  'Unable to continue authorization': 'Unable to continue authorization',
  'Unable to continue decoupled authorization': 'Unable to continue decoupled authorization',
  'Unable to handle authentication status "{status}"': 'Unable to handle authentication status "{status}"',
  'Unknown error occurred': 'Unknown error occurred',
  'You need to close this window': 'You need to close this window',
  'Authentication cancelled': 'Authentication cancelled',
  // Consent
  'Authentication is initiated by {0}.': 'Authentication is initiated by {0}.',
  'After you complete authentication, {0} will be shared with the authentication initiator.': 'After you complete authentication, {0} will be shared with the authentication initiator.',
  'your payment accounts data': 'your payment accounts data',
  'the list of your payment accounts': 'the list of your payment accounts',
  'the list of your payment accounts and accounts balances': 'the list of your payment accounts and accounts balances',
  'the list of your payment accounts and accounts transactions': 'the list of your payment accounts and accounts transactions',
  'the list of your payment accounts, accounts balances and transactions': 'the list of your payment accounts, accounts balances and transactions',
  'By pressing {0} button you agree with the {1}.': 'By pressing {0} button you agree with the {1}.',
  'Press {0} button if you are not willing to share your payment accounts data.': 'Press {0} button if you are not willing to share your payment accounts data.',
  // Payment consent
  'Payment details': 'Payment details',
  'Payment ID provided by the application: {0}': 'Payment ID provided by the application: {0}',
  'Account number where to transfer funds: {0}': 'Account number where to transfer funds: {0}',
  'Payee name in the payment: {0}': 'Payee name in the payment: {0}',
  'Payee country: {0}': 'Payee country: {0}',
  'Payment amount: {0}': 'Payment amount: {0}',
  'Message or reference number in the payment: {0}': 'Message or reference number in the payment: {0}',
  'Payment is initiated by {0}.': 'Payment is initiated by {0}.',
  'After you complete authentication, your payment consent will be requested by your account servicing payment service provider.': 'After you complete authentication, your payment consent will be requested by your account servicing payment service provider.',
  'terms of service': 'terms of service',
  'Press {0} button if you are not willing to complete this payment.': 'Press {0} button if you are not willing to complete this payment.',
  'Select Payment Account': 'Select Payment Account',
  'Confirm': 'Confirm',
  // Backend messages
  '10 digit client number': '10 digit client number',
  '10 digit organisation number (or 12 digit personal number if the company is a sole proprietorship)': '10 digit organisation number (or 12 digit personal number if the company is a sole proprietorship)',
  '10 digit organization number.': '10 digit organization number.',
  '17 digit card number (starting with 6703)': '17 digit card number (starting with 6703)',
  '6 digit Handelsbanken customer number': '6 digit Handelsbanken customer number',
  '8 digits CVR number': '8 digits CVR number',
  '9 digits Organisasjonsnummer': '9 digits Organisasjonsnummer',
  'Agreement number': 'Agreement number',
  'Agreement number for Nordea Corporate Netbank': 'Agreement number for Nordea Corporate Netbank',
  'Bank user ID': 'Bank user ID',
  'Business identity code (Y-tunnus) in 1234567-8 format': 'Business identity code (Y-tunnus) in 1234567-8 format',
  'Business identity code which is displayed in the Corporate Internet bank settings': 'Business identity code which is displayed in the Corporate Internet bank settings',
  'Client ID': 'Client ID',
  'Client number': 'Client number',
  'Company ID': 'Company ID',
  'Company number': 'Company number',
  'Corporate ID': 'Corporate ID',
  'Corporate registration ID': 'Corporate registration ID',
  'Currency code': 'Currency code',
  'Digit card number': 'Digit card number',
  'Disposer': 'Disposer',
  'E-mail': 'E-mail',
  'E-mail used for authenticating to Holvi': 'E-mail used for authenticating to Holvi',
  'Either the 14 digit SEB identifier for the company or the 10 digit organization number': 'Either the 14 digit SEB identifier for the company or the 10 digit organization number',
  'FKDN (without subaccount number): 3 digit branch number + 7 digit customer number': 'FKDN (without subaccount number): 3 digit branch number + 7 digit customer number',
  'For Swedish Corporates, this is their Organisation number or SHB number, and for Sole Traders (Enskild firma), it is their Personal number, all of which are 10 digits.': 'For Swedish Corporates, this is their Organisation number or SHB number, and for Sole Traders (Enskild firma), it is their Personal number, all of which are 10 digits.',
  'IBAN': 'IBAN',
  'ID, NIE, Passport': 'ID, NIE, Passport',
  'Login ID used in MyBRD aplications': 'Login ID used in MyBRD aplications',
  'Login Name': 'Login Name',
  'Mandate ID': 'Mandate ID',
  'Norwegian national identity number in the format DDMMYYXXXXX (11 digits)': 'Norwegian national identity number in the format DDMMYYXXXXX (11 digits)',
  'Online banking PIN': 'Online banking PIN',
  'Online banking Password': 'Online banking Password',
  'Organisation ID in the format TBxxxxx or TXxxxxx': 'Organisation ID in the format TBxxxxx or TXxxxxx',
  'Organisation number': 'Organisation number',
  'PIN': 'PIN',
  'Password': 'Password',
  'Password for Aktia Internet bank': 'Password for Aktia Internet bank',
  'Password used for authenticating to Holvi': 'Password used for authenticating to Holvi',
  'Personal ID': 'Personal ID',
  'Personal ID number': 'Personal ID number',
  'Personal code': 'Personal code',
  'Personal code of the user': 'Personal code of the user',
  'Personal signatory number': 'Personal signatory number',
  'Personal username for online banking': 'Personal username for online banking',
  'Postbank ID': 'Postbank ID',
  'Social security number (Personnummer)': 'Social security number (Personnummer)',
  'Social security number in the format YYYYMMDDXXXX': 'Social security number in the format YYYYMMDDXXXX',
  'Swedish social security number in the format YYYYMMDDXXXX': 'Swedish social security number in the format YYYYMMDDXXXX',
  'The IBAN of the user authenticating': 'The IBAN of the user authenticating',
  'The currency code': 'The currency code',
  'The user ID of the user authenticating': 'The user ID of the user authenticating',
  'Unique personal ID number': 'Unique personal ID number',
  'User ID': 'User ID',
  'User ID for Aktia Internet bank': 'User ID for Aktia Internet bank',
  'User ID for Nordea Corporate Netbank': 'User ID for Nordea Corporate Netbank',
  'User ID for online banking': 'User ID for online banking',
  'User ID in the format XX000000': 'User ID in the format XX000000',
  'User ID used to log in to the bank': 'User ID used to log in to the bank',
  'Username': 'Username',
  'Username used to log in to the bank': 'Username used to log in to the bank',
  'VR NetKey': 'VR NetKey',
  'WebSSO user name': 'WebSSO user name',
}
